import 'core-js/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import 'Styles/globals.css';
import '../frontend/src/index.css';
import './tdarr-overrides.css';
import App from './App';
import LiveUpdates from './LiveUpdates';
import { applyTheme, watchTheme } from './theme';

applyTheme();
watchTheme();

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 2, refetchOnWindowFocus: false } }
});

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={window.Sonarr.urlBase || undefined}>
        <LiveUpdates />
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
